module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Light-0c8db2a8d244efadaeeea5a399f33e33.woff2";